import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { CatalogueEntry } from "../CatalogueEntry";
import { Catalogue } from "@singularsystems/neo-react-services";
import { AppService, DomainTypes } from "../../../DomainTypes";
import NoticePeriod from "../../../Models/Catalogue/Investments/NoticePeriod";

export default class NoticePeriodCatalogueEntry extends CatalogueEntry<NoticePeriod> {

    private investmentsApiClient = AppService.get(DomainTypes.ApiClients.CatalogueInvestment);

    constructor() {
        super("Notice Period", NoticePeriod);
    }

    public get editRole() {
        return CatalogueRoles.NoticePeriod.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.noticePeriods;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.investmentsApiClient.saveNoticePeriods;
    }
    
    public renderRow(item: NoticePeriod, meta: Model.TransformMetaType<NoticePeriod>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.noticePeriodName} />
                <NeoGrid.Column bind={meta.months} />
                <NeoGrid.Column bind={meta.days} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}